/*! *********************************************************************
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import _map from 'lodash/map';

const theme = ({
  id,
  title,
  description,
  imageUrl,
  collections: rawCollections,
  status,
  weight,
  createdAt,
  updatedAt,
}) => {
  const collections = _map(rawCollections.items, (c) => c.id);

  return {
    id,
    title,
    description,
    imageUrl,
    collections,
    status,
    weight,
    createdAt,
    updatedAt,
    nbCollections: rawCollections.total,
  };
};

export default theme;
